import { configure } from "@tamara/web-frontend-library";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/i18n"; // initialize i18n before app renders
import { App } from "@/app/App";
import { initializeLoggerInBackground } from "@/services/logging/initializer";
import { initializeTrackerInBackground } from "@/services/tracking/initializer";

import "./main.css";

// Configure the shared frontend library before anything logs or tracks.
// Note: configure() REPLACES the whole config, it does not merge — any option
// omitted here reverts to the library default. Pass everything in one call.
// Imperative, not a React provider — it must run before render. Without a
// backend session (local dev) logging falls back to console.* and River
// tracking no-ops, so this is safe in every environment.
configure({ service: "payment-plans-ui" });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Initialize logger in the background without blocking app startup
import { log } from "@/services/logging/logger";
initializeLoggerInBackground().catch((error: Error) => {
  log("error", "main", "Failed to initialize logger", error);
});

// Initialize tracker in the background without blocking app startup
initializeTrackerInBackground().catch((error: Error) => {
  log("error", "main", "Failed to initialize tracker", error);
});
